import * as M from 'shared/types/models';

export function includesRange(thatMaybeIncluded: M.Range, thatIncludes: M.Range): boolean {
  return thatMaybeIncluded.start >= thatIncludes.start && thatMaybeIncluded.end <= thatIncludes.end
}
